import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=7d1fd724"
import script from "./FullScreenLayout.vue?vue&type=script&lang=js"
export * from "./FullScreenLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1fd724')) {
      api.createRecord('7d1fd724', component.options)
    } else {
      api.reload('7d1fd724', component.options)
    }
    module.hot.accept("./FullScreenLayout.vue?vue&type=template&id=7d1fd724", function () {
      api.rerender('7d1fd724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/FullScreenLayout.vue"
export default component.exports